export default "__VITE_ASSET__604b5ab3__"